import React from 'react';
import styled from 'styled-components';
import VipIcon from '../../../assets/svg/vip-icon.svg';
import { TextMain } from '../../typography/Texts';
import { BidderDto } from '../../../features/onsite/utils/bidderTypes';
import { theme } from '../../../assets/styles/theme';
import { extractUserName } from '../../../utils/nameUtils';

const Container = styled.div`
  flex-direction: row;
  align-items: center;
`;

const NameText = styled(TextMain)`
  color: ${theme.color.black};
  font-weight: 700;
`;

const StyledVipIcon = styled.img`
  margin-left: 5px;
  width: 16px;
  height: 16px;
`;

interface Props {
  bidder: BidderDto;
}

const BidderDetails = ({ bidder }: Props) => {
  return (
    <Container>
      <NameText>{extractUserName(bidder)}</NameText>
      {bidder.vip && <StyledVipIcon src={VipIcon} />}
    </Container>
  );
};

export default BidderDetails;
